export default function numberWithCommas(number: number, formatWholeNumbers: boolean = false): string {
    let formattedNumber = number.toString();

    if (formatWholeNumbers && Number.isInteger(number) && number > 0 && !formattedNumber.includes(".")) {
        formattedNumber += ".00";
    }

    return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}